<template>
    <div class="mainsearch flight-search">
        <form @submit.prevent="submitHandler">
            <div class="form">
                <div class="row">
                    <div class="col-12">
                        <div class="mainsearch__heading">Інформація по рейсу</div>
                    </div>
                    <div class="col-12">
                        <div class="form-group privilage-group">
                            <label>Тип користувача <span class="required-icon"> *</span></label>
                            <div class="radiolist">
                                    <div class="radioitem" v-for="(item, index) in userTypeList" v-if="item.id < 3" :key="index">
                                    <input type="radio" name="userType" :id="`usertype-${index}`" :checked="userType.key === item.key">
                                    <label :for="`usertype-${index}`" @click="userType = item">{{item.value}}</label>
                                    <div class="check"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                      <div class="form-group">
                        <label>
                          <span>Державний номер ТЗ</span> <span class="required-icon"> *</span>
                        </label>
                        <div :class="{'search-group' : true, 'is-invalid' : (!$v.car.number.required && submitCheck) }">
                          <input
                            type="text"
                            :class="{'form-control' : true, 'uppercase': true, 'is-invalid' : (!$v.car.number.required && submitCheck) }"
                            v-mask="'MMMMMMMMM'"
                            v-model="car.number"
                            placeholder="Наприклад, АХ1111ВС"
                          >
                          <div class="autocomplete-number"
                            v-if="carNumberInfo.status"
                            @click="setCarInfo(true)"
                          >
                            <div class="inn-items">
                              <div class="row mt-2" v-if="carNumberInfo.mark || carNumberInfo.model">
                                <div class="col-md-12">
                                  <b>Марка та модель: </b><span v-if="carNumberInfo.mark">{{carNumberInfo.mark}}</span>
                                  <span v-if="carNumberInfo.model">{{carNumberInfo.model}}</span>
                                </div>
                              </div>
                              <div class="row mt-2" v-if="carNumberInfo.vin">
                                <div class="col-md-12">
                                  <b>Номер кузова (VIN-код): </b><span>{{carNumberInfo.vin}}</span>
                                </div>
                              </div>
                              <div class="row mt-2" v-if="carNumberInfo.year">
                                <div class="col-md-12">
                                  <b>Рік випуску авто: </b><span>{{carNumberInfo.year}}</span>
                                </div>
                              </div>
                              <div class="row mt-2" v-if="carNumberInfo.city.name_full_name_ua">
                                <div class="col-md-12">
                                  <b>Місто: </b><span>{{carNumberInfo.city.name_full_name_ua}}</span>
                                </div>
                              </div>
                              <div class="row mt-2" v-if="carNumberInfo.age">
                                <div class="col-md-12">
                                  <b>Вік власника ТЗ: </b><span>{{carNumberInfo.age}}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="load-insured-list spinner-border spinner-border-sm" role="status" v-if="numberLoading"></div>
                          <div class="hint-icon" data-placement="bottom" data-toggle="tooltip" title="Для авто зареєстрованих в Україні держномер повинен відповідати одному з шаблонів: ЦЦЦЦЦЦББ, ЦЦЦЦЦББ, ЦЦЦЦББ, ББЦЦЦЦ, ББЦЦЦЦЦ, БББЦЦЦЦ, ББББЦЦЦЦ, ЦЦЦЦБББ, БЦЦЦЦББ, ЦЦЦЦБЦ, ББЦЦЦЦББ, ЦЦББЦЦЦЦ, ЦЦЦЦЦЦ, ТЦББЦЦЦЦ, ТЦЦЦЦЦББ, CDPЦЦЦ, CDPЦЦЦЦ, CMDЦЦЦЦ, DPЦЦЦЦ, DPЦЦЦЦЦ, DPЦЦЦЦЦЦ, SЦЦЦЦЦЦ, FЦЦЦЦЦЦ, CЦЦЦЦЦЦ, DЦЦЦЦЦЦ, TЦЦЦЦЦЦ, MЦЦЦЦЦЦ, KЦЦЦЦЦЦ, HЦЦЦЦЦЦ, PЦЦЦЦЦЦ, SЦЦЦЦЦ, ЦЦЦFЦЦЦЦЦ, ЦЦЦSЦЦЦЦЦ, ЦЦЦBЦЦЦЦЦ, ЦЦЦCЦЦЦЦЦ, ЦЦЦDЦЦЦЦЦ, ЦЦЦDPЦЦЦЦ, ЦЦЦCCЦЦЦЦ, ЦЦЦCDPЦЦЦЦ, ББЦЦЦБ де Ц - цифра, Б - літера кирилиці або латиниці (без Q)">
                            <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="8" cy="8" r="7.5" fill="white" stroke="#9FA3AB"/>
                              <path d="M7.772 4.848C7.18 4.848 6.688 5.104 6.296 5.616L5.48 4.692C5.704 4.324 6.028 4.028 6.452 3.804C6.876 3.58 7.344 3.468 7.856 3.468C8.64 3.468 9.252 3.672 9.692 4.08C10.148 4.48 10.376 4.98 10.376 5.58C10.376 6.108 10.272 6.536 10.064 6.864C9.856 7.184 9.564 7.496 9.188 7.8C9.14 7.84 9.076 7.892 8.996 7.956C8.924 8.02 8.864 8.072 8.816 8.112C8.776 8.144 8.72 8.192 8.648 8.256C8.584 8.32 8.536 8.372 8.504 8.412C8.472 8.444 8.428 8.496 8.372 8.568C8.324 8.632 8.292 8.688 8.276 8.736C8.26 8.784 8.236 8.848 8.204 8.928C8.18 9.008 8.172 9.08 8.18 9.144C8.196 9.208 8.204 9.288 8.204 9.384L6.944 9.396C6.896 9.1 6.892 8.84 6.932 8.616C6.98 8.384 7.08 8.176 7.232 7.992C7.392 7.8 7.52 7.664 7.616 7.584C7.72 7.496 7.884 7.368 8.108 7.2C8.636 6.832 8.9 6.392 8.9 5.88C8.9 5.592 8.792 5.348 8.576 5.148C8.36 4.948 8.092 4.848 7.772 4.848ZM6.68 11.1C6.68 10.868 6.768 10.664 6.944 10.488C7.128 10.304 7.356 10.212 7.628 10.212C7.876 10.212 8.084 10.304 8.252 10.488C8.428 10.664 8.516 10.868 8.516 11.1C8.516 11.364 8.432 11.592 8.264 11.784C8.096 11.968 7.884 12.06 7.628 12.06C7.356 12.06 7.128 11.968 6.944 11.784C6.768 11.592 6.68 11.364 6.68 11.1Z" fill="#9FA3AB"/>
                            </svg>
                          </div>
                        </div>
                        <small class="error" v-if="!$v.car.number.required && submitCheck">Вкажіть державний номер ТЗ</small>
                      </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="form-group">
                            <label>Тип ТЗ (категорія) <span class="required-icon"> *</span></label>
                            <multiselect
                                :class="{'form-control' : true, 'is-invalid' : isInvalid(this.carType)}"
                                v-model="carType"
                                :options="carTypes"
                                placeholder="Виберіть тип транспортного засобу"
                                :max-height="120"
                                :allow-empty="false"
                                label="name"></multiselect>

                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="form-group">
                            <label>Повна маса авто, кг <span class="required-icon"> *</span></label>
                            <input
                                type="text"
                                :class="['form-control', {'is-invalid': ((!$v.totalWeight.required || !$v.totalWeight.numeric) && submitCheck)}]"
                                v-mask="'######'"
                                v-model="totalWeight"
                                placeholder="Наприклад, 1500"
                            >
                            <small class="error" v-if="(!$v.totalWeight.required || !$v.totalWeight.numeric) && submitCheck">Вкажіть повну масу авто</small>
                        </div>
                    </div>
                    <div class="col-lg-4" v-if="carType.group !== 'TRAILER'">
                        <div class="form-group">
                            <label>К-ть місць для сидіння, з водієм</label>
                            <input
                                type="text"
                                :class="['form-control', {'is-invalid': (!$v.numberOfSeats.numeric && submitCheck)}]"
                                v-mask="'###'"
                                v-model="numberOfSeats"
                                placeholder="Наприклад, 5"
                            >
                            <small class="error" v-if="!$v.numberOfSeats.numeric && submitCheck">Вкажіть коректно кількість місць</small>
                            <div class="form-group__descr">*Для СК "Oranta" вкажіть кількість місць для сидіння</div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="form-group">
                            <label>Рік випуску авто</label>
                            <input
                                type="text"
                                :class="['form-control', {'is-invalid': ((!$v.car.year.numeric || !$v.car.year.minLength || !$v.car.year.maxLength) && submitCheck)}]"
                                v-mask="'####'"
                                v-model="car.year"
                                placeholder="Наприклад, 2020"
                            >
                            <small class="error" v-if="(!$v.car.year.numeric || !$v.car.year.minLength || !$v.car.year.maxLength) && submitCheck">Вкажіть коректний рік випуску авто</small>
                            <div class="form-group__descr">*Для СК "Oranta" вкажіть рік випуску авто</div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="form-group">
                            <label>Територія покриття <span class="required-icon"> *</span></label>
                            <div class="city-container-item">
                                <countrySearch
                                :countrySelect='countrySelect'
                                v-bind:countryStore="this.countryStore"/>
                                <small class="error" v-if="!$v.country.required && submitCheck">Вкажіть територію покриття</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="form-group">
                            <label>Початок дії <span class="required-icon"> *</span></label>
                            <date-picker v-model="startDate" :config="optionsStartDate" :class="['form-control', 'date-input', {invalid: (!$v.startDate.required && submitCheck)}]" placeholder="Дати від’їзду"></date-picker>
                            <small class="error" v-if="!$v.startDate.required && submitCheck">Вкажіть дати від’їзду</small>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="form-group">
                            <label>Період дії <span class="required-icon"> *</span></label>
                            <multiselect
                                :class="['form-control', {invalid: (!$v.periodOptions.required && periodOptionStatus)}]"
                                v-model="periodOption"
                                :options="periodOptions"
                                placeholder="Виберіть період дії"
                                :max-height="120"
                                @input="checkPeriodOption"
                                :allow-empty="false"
                                :searchable="false"
                                label="name"></multiselect>
                            <small class="error" v-if="!$v.periodOptions.required && periodOptionStatus">Вкажіть період дії</small>

                        </div>
                    </div>
                    <div class="col-lg-12 insurance-nav d-flex justify-content-center">
                        <button class="btn-blue-w" type="submit">
                            Показати результати
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import {
  maxLength, minLength, numeric, required, requiredIf,
} from 'vuelidate/lib/validators';
import countrySearch from '@/components/app/forms/CountrySearch';

export default {
  components: { countrySearch, Multiselect },
  props: [
    'dataCar',
    'dataCountry',
    'dataCityFrom',
    'dataCarType',
    'dataUserType',
    'dataStartDate',
    'dataPeriodOption'
  ],
  data: function () {
    return {
      car: {
        vin: null,
        age: null,
        birthDateOwner: null,
        year: null,
        number: null,
        brand: null,
        model: null,
        autoCategory: null,
        kilometers: null,
        birthdayAt: null,
        city: null,
        additional_parameters: {},
      },
      carNumberInfo: {
        status: false,
        mark: null,
        model: null,
        vin: null,
        year: null,
        age: null,
        birthDateOwner: null,
        kilometers: null,
        birthdayAt: null,
        autoCategory: null,
        additional_parameters: {},
        city: {
          id: null,
          name_ua: null,
          name_full_name_ua: null
        }
      },
      numberLoading:false,
      //TODO этот момент переписать, когда поменяем форму управления
      citiesOptions: [
        { 'id': 1,'name': 'Київ','name_full_name_ua': 'м. Київ, Україна', 'zone':1 },
        { 'id': 9,'name': 'Дніпро','name_full_name_ua': 'м. Дніпро, Дніпропетровська  обл., Україна', 'zone':2 },
        { 'id': 11,'name': 'Львів','name_full_name_ua': 'м. Львів, Львівська  обл., Україна', 'zone':1 },
        { 'id': 13,'name': 'Одеса','name_full_name_ua': 'м. Одеса, Одеська  обл., Україна', 'zone':2 },
        { 'id': 14,'name': 'Харків','name_full_name_ua': 'м. Харків, Харківська  обл., Україна', 'zone':2 },
        { 'id': 16,'name': 'Запоріжжя','name_full_name_ua': 'м. Запоріжжя, Запорізька  обл., Україна', 'zone':3 },
        { 'id': 17,'name': 'Кривий Ріг','name_full_name_ua': 'м. Кривий Ріг, Дніпропетровська  обл., Україна', 'zone':3 },
        { 'id': 21,'name': 'Вінниця','name_full_name_ua': 'м. Вінниця, Вінницька  обл., Україна', 'zone':4 },
        { 'id': 36,'name': 'Маріуполь','name_full_name_ua': 'м. Маріуполь, Донецька  обл., Україна', 'zone':4 },
        { 'id': 41,'name': 'Полтава','name_full_name_ua': 'м. Полтава, Полтавська  обл., Україна', 'zone':4 }
      ],
      carType: {
        'name':'Легкові автомобілі',
        'group':'CAR',
        'external_id':'A',
        'engines': [
          { 'name':'до 1600 см3','value':'A1' },
          { 'name':'1601-2000 см3','value':'A2' },
          { 'name':'2001-3000 см3','value':'A3' },
          { 'name':'более 3001 см3','value':'A4' },
        ],
        'types':[]
      },
      carTypes: [
        {
          'name':'Легкові автомобілі',
          'group':'CAR',
          'external_id':'A',
          'engines':[
            { 'name':'до 1600 см3','value':'A1' },
            { 'name':'1601-2000 см3','value':'A2' },
            { 'name':'2001-3000 см3','value':'A3' },
            { 'name':'более 3001 см3','value':'A4' }
          ],
          'types':[]
        },
        { 'name':'Автобус',
          'group':'BUS',
          'external_id':'E',
          'engines':[],
          'types':[
            { 'name':'менше 20 осіб','value':'E1' },
            { 'name':'більше 20 осіб','value':'E2' }
          ]
        },
        { 'name':'Вантажні автомобілі',
          'group':'CARGO',
          'external_id':'C',
          'engines':[],
          'types':[
            { 'name':'С0 (з повною масою до 2,4т та вантажопідйомністю до 2т)','value':'C0' },
            { 'name':'С1 (з повною масою більше 2,4т та вантажопідйомністю до 2т (включно))','value':'C1' },
            { 'name':'С2 (з вантажопідйомністю більше 2т)','value':'C2' }
          ]
        },
        {
          'name':'Причіп, Трейлер',
          'group':'TRAILER',
          'engine':null,
          'external_id':'F',
          'engines':[],
          'types':[
            { 'name':'До вантажного авто','value':'F' },
            { 'name':'До легкового авто','value':'F' }
          ]
        },
        { 'name':'Мотоцикли та моторолери',
          'group':'BIKE',
          'external_id':'B',
          'engines':[
            { 'name':'300 см3 або менше','value':'B1' },
            { 'name':'більше 300 см3','value':'B2' }
          ],
          'types':[]
        }
      ],
      // Довідник авто (Інфотех) повертає категорію в кодуванні ОСЦПВ,
      // а Greencard оперує групами — мапимо код на group з carTypes
      osagoCategoryGroups: {
        A1: 'BIKE', A2: 'BIKE',
        B1: 'CAR', B2: 'CAR', B3: 'CAR', B4: 'CAR', B5: 'CAR',
        C0: 'CARGO', C1: 'CARGO', C2: 'CARGO',
        D1: 'BUS', D2: 'BUS',
        E: 'TRAILER', F: 'TRAILER',
      },
      totalWeight: null,
      numberOfSeats: null,
      // Значення, підставлені з довідника для поточного держномера (по полях).
      // При зміні номера перезаписуємо лише їх — ручний ввід не чіпаємо
      // (крім випадку, коли для нового авто довідник дав своє значення).
      prefilledFromLookup: { carTypeGroup: null, totalWeight: null, year: null, numberOfSeats: null },
      // Держномер, для якого довідник уже запитано (або дані прийшли з розрахунку).
      // Повторний запит для того самого номера затирав би введені агентом дані.
      lookedUpNumber: null,
      periodOption: { 'id': 12, 'name' : '12 міс' },
      periodOptions: [
        { 'id': 15, 'name' : '15 д' },
        { 'id': 21, 'name' : '21 д' },
        { 'id': 1, 'name' : '1 міс' },
        { 'id': 2, 'name' : '2 міс' },
        { 'id': 3, 'name' : '3 міс' },
        { 'id': 4, 'name' : '4 міс' },
        { 'id': 5, 'name' : '5 міс' },
        { 'id': 6, 'name' : '6 міс' },
        { 'id': 7, 'name' : '7 міс' },
        { 'id': 8, 'name' : '8 міс' },
        { 'id': 9, 'name' : '9 міс' },
        { 'id': 10, 'name' : '10 міс' },
        { 'id': 11, 'name' : '11 міс' },
        { 'id': 12, 'name' : '12 міс' },
      ],
      country: null,
      startDate: moment(new Date(new Date().getFullYear(), new Date().getMonth(), (new Date().getDate() + 1))).format('DD.MM.YYYY'),
      userTypeList: [],
      userType: {},
      endDate: null,
      ticketNumber: null,
      ticketPrice: null,
      submitCheck: false,
      periodOptionStatus: false,
      optionsStartDate: {
        format: 'DD.MM.YYYY',
        useCurrent: false,
        minDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
        maxDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 90),
        locale: 'uk',
        icons: {
          previous: 'icon arrow-point-to-left',
          next: 'icon arrow-point-to-right',
          time: 'fa fa-clock-o',
          date: 'fa fa-calendar',
        },
      },
      errors: {},
    };
  },
  validations: {
    startDate:{ required },
    periodOption:{ required },
    country:{ required },
    periodOptions:{ required },
    carType:{ required },
    totalWeight:{ required, numeric },
    numberOfSeats: { required: requiredIf(function(){
      return this.carType.group !== 'TRAILER';
    }), numeric },
    car: {
      number: { required },
      year: { required, minLength: minLength(4), maxLength: maxLength(4), numeric },
    },
  },
  created() {
    this.userTypeList = this.$store.getters.CUSTOMER_TYPES;
    this.setCustomerType();
    this.fetchParams();
  },
  computed: {
    countryStore() {
      if(this.dataCountry){
        return this.dataCountry;
      }
    },
  },
  watch: {
    'car.number': function(newVal) {
      if (!newVal) {
        this.car = {
          vin: null,
          year: null,
          number: null,
          age: null,
          birthDateOwner: null,
          brand: null,
          model: null,
          autoCategory: null,
          kilometers: null,
          birthdayAt: null,
          city: null,
          additional_parameters: {},
        };
        this.carNumberInfo.status = false;
        this.applyLookupResult(null);
        return;
      }

      this.car.number = newVal.replace(/\s/g, '').replace(/,/g, '');

      if (this.car.number?.length === 8) {
        this.car.number = this.car.number.toUpperCase();
        if (this.car.number !== this.lookedUpNumber) {
          this.getCarInfo();
        }
      } else {
        this.carNumberInfo.status = false;
      }
    },
  },

  methods: {
    submitHandler() {
      this.submitCheck = true;
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      this.car.additional_parameters = {
        ...this.car.additional_parameters,
        totalWeight: this.totalWeight,
        numberOfSeats: this.carType.group !== 'TRAILER' ? this.numberOfSeats : null,
      };
      let params = {
        car: this.car,
        carType: this.carType,
        carNumber: this.car?.number,
        userType: this.userType,
        country: this.country,
        startDate: (typeof this.startDate.getMonth === 'function')?this.startDate.toLocaleDateString():this.startDate,
        periodOption: this.periodOption,
      };
      this.$store.commit('SET_GREENCARD_SEARCH_PARAMS', params);
      if (this.checkResultRoute()) {
        this.$router.go();
      } else {
        this.$router.push({ name: 'greenCardResults' });
      }
    },
    setCustomerType() {
      //TODO Установка флага "Фізична особа" по умолчанию
      this.userType = this.userTypeList.find(option => option.id === 1);
    },
    countrySelect(data) {
      this.country = data.country;
    },
    isInvalid(val) {
      return val == null && this.submitForm;
    },
    fetchParams() {
      // Копія, а не посилання на об'єкт зі store: інакше будь-яка зміна у формі
      // (зокрема відповідь довідника) правила б параметри вже зробленого розрахунку
      this.car = this.dataCar ? JSON.parse(JSON.stringify(this.dataCar)) : this.car;
      this.totalWeight = this.dataCar?.additional_parameters?.totalWeight ?? this.totalWeight;
      this.numberOfSeats = this.dataCar?.additional_parameters?.numberOfSeats ?? this.numberOfSeats;
      this.carType = this?.dataCarType ?? this.carType;
      if (this.car.number) {
        // Дані вже з розрахунку — довідник не перезапитуємо, бо для авто,
        // якого в ньому немає, він повернув би порожні поля замість введених
        this.lookedUpNumber = this.car.number.trim().toUpperCase();
        this.prefilledFromLookup = {
          carTypeGroup: this.carType?.group ?? null,
          totalWeight: this.totalWeight,
          year: this.car.year ?? null,
          numberOfSeats: this.numberOfSeats,
        };
      }
      this.userType = this?.dataUserType ?? this.userTypeList.find(option => option.id === 1);
      this.startDate = this?.dataStartDate ?? this.startDate;
      this.periodOption = this?.dataPeriodOption ?? this.periodOption;
      this.country = this?.dataCountry ?? this.country;
    },
    checkResultRoute() {
      return this.$router.currentRoute.name === 'greenCardResults';
    },
    checkPeriodOption(){
      this.periodOptionStatus = !(!this.periodOption || this.periodOption.id === undefined);
    },
    async getCarInfo() {
      if (this.car.number && this.car.number.length) {
        const number = this.car.number.trim().toUpperCase();
        this.lookedUpNumber = number;
        this.numberLoading = true;
        await axios({ url: '/api/directories/car/' + number, method: 'GET' }).then(({ data }) => {
          let result = data.data;
          const found = Boolean(result.number);

          this.carNumberInfo.status = found;

          this.carNumberInfo.mark = result.mark;
          this.carNumberInfo.model = result.model;
          this.carNumberInfo.vin = result.vin;
          this.carNumberInfo.age = result.age;
          this.carNumberInfo.birthDateOwner = result.birthDateOwner;
          this.carNumberInfo.year = result.year;
          this.carNumberInfo.autoCategory = result.autoCategory;
          this.carNumberInfo.kilometers = this.$store.state.osagoStore?.requestData?.car && this.$store.state.osagoStore.requestData.car?.kilometers ? this.$store.state.osagoStore?.requestData.car.kilometers : null;
          this.carNumberInfo.birthdayAt = this.$store.state.osagoStore?.requestData?.car && this.$store.state.osagoStore.requestData.car.birthdayAt ? this.$store.state.osagoStore.requestData.car.birthdayAt : null;
          if (found) {
            this.car.brand = result.mark;
            this.car.model = result.model;
            this.car.autoCategory = result.autoCategory;
            this.car.vin = result.vin;
            this.car.age = result.age;
            this.car.birthDateOwner = result.birthDateOwner;
            this.car.birthdayAt = result.age
              ? moment(result.birthDateOwner, 'YYYY-MM-DD').format('DD.MM.YYYY')
              : null;
            this.car.additional_parameters = result.additionalParameters || {};
            this.carNumberInfo.additional_parameters = result.additionalParameters || {};
          } else {
            // Авто немає в довіднику: прибираємо все, що лишилось від попереднього
            // номера. Повна маса й місця живуть у полях форми і потраплять
            // в additional_parameters при розрахунку (submitHandler)
            this.car.brand = null;
            this.car.model = null;
            this.car.autoCategory = null;
            this.car.vin = null;
            this.car.age = null;
            this.car.birthDateOwner = null;
            this.car.birthdayAt = null;
            this.car.additional_parameters = {};
            this.carNumberInfo.additional_parameters = {};
          }

          this.applyLookupResult(result);

          if(result.city){
            this.carNumberInfo.city.id = result.city.id;
            this.carNumberInfo.city.name_ua = result.city.name_ua;
            this.carNumberInfo.city.name_full_name_ua = result.city.name_full_name_ua;
            this.carNumberInfo.city.zone = result.city.zone;
            // Місто реєстрації з техпаспорту переносимо в дані авто,
            // щоб воно збереглось до кроку оформлення (поле "Мiсце реєстрації власника ТЗ")
            if (result.city.zone) {
              this.car.city = result.city;
            }
          }else{
            this.carNumberInfo.city.id = null;
            this.carNumberInfo.city.name_ua = null;
            this.carNumberInfo.city.name_full_name_ua = null;
            this.carNumberInfo.city.zone = null;
            this.car.city = null;
          }

          this.numberLoading = false;
        }).catch(err => {
          // Дозволяємо повторити запит для цього ж номера після помилки
          this.lookedUpNumber = null;
          this.numberLoading = false;
          console.log(err);
        });
      }
    },
    setCarInfo() {
      this.disableCheckCarData = true;
    },
    // Записує значення з довідника в поле, якщо довідник щось дав або якщо
    // в полі досі стоїть попереднє автопідставлене значення (не ручний ввід)
    applyLookupValue(field, current, value, set) {
      if (value !== null || String(current ?? '') === String(this.prefilledFromLookup[field] ?? '')) {
        set(value);
      }
      this.prefilledFromLookup[field] = value;
    },
    // result === null — номер стерли: прибираємо все, що було підставлено з довідника
    applyLookupResult(result) {
      const category = String(result?.type || result?.autoCategory || '').toUpperCase();
      this.applyLookupValue('carTypeGroup', this.carType?.group, this.osagoCategoryGroups[category] ?? null, (group) => {
        this.carType = this.carTypes.find(type => type.group === (group ?? 'CAR'));
      });
      this.applyLookupValue('totalWeight', this.totalWeight, result?.additionalParameters?.totalWeight || null, (value) => {
        this.totalWeight = value;
      });
      this.applyLookupValue('year', this.car.year, result?.year || null, (value) => {
        this.car.year = value;
      });
      this.applyLookupValue('numberOfSeats', this.numberOfSeats, result?.additionalParameters?.numberOfSeats || null, (value) => {
        this.numberOfSeats = value;
      });
    },
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
